import { useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Badge } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import PropTypes from "prop-types";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { BsBarChartLineFill } from "react-icons/bs";
import {
  MdHome,
  MdSearch,
  MdAccessTime,
  MdAdminPanelSettings,
  MdSettings,
  MdExpandMore,
  MdNotifications,
  MdGavel,
  MdFeed,
  MdEmail,
  MdAssessment,
  MdStore,
  MdHelpOutline,
  MdImage,
  MdMilitaryTech,
  MdExitToApp,
  MdClose,
  MdContactSupport,
} from "react-icons/md";
import { AiFillMessage, AiFillQuestionCircle } from "react-icons/ai";
import { FaPercentage, FaUsers } from "react-icons/fa";
import { RiListOrdered } from "react-icons/ri";
import { GiSlicedBread } from "react-icons/gi";
import { BiCommentDetail } from "react-icons/bi";
import NewspaperSharpIcon from "@mui/icons-material/NewspaperSharp";
import { StyledDrawerLink } from "../Link";
import {
  SearchBoxWrapper,
  StyledAppBar,
  StyledDrawer,
  StyledDrawerHeader,
  StyledInputBase,
  StyledList,
  StyledMain,
  StyledSearch,
  StyledTypo,
  StyledAccordion,
  StyledAccordionDetails,
  StyledSetting,
} from "./Drawer.style";
import { useLocation, useNavigate } from "react-router-dom";
import AccordionSummary from "@mui/material/AccordionSummary";
import useAuth from "hooks/use-auth";
import { useForm } from "react-hook-form";
import ImgContainer from "components/shared/Image";
import logo from "assets/img/logo-512.png";
import useHttp from "hooks/use-http";
import { getAdminInfoRequest } from "api/requests";
import { ADMIN_ROUTES } from "constants";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import { MdPrivacyTip } from "react-icons/md";
import { BiCategory } from "react-icons/bi";
import { GiSofa } from "react-icons/gi";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { getStatusRequest } from "api/requests";

const drawerWidth = 260;
let ADMIN_PREMISSION = { isMutated: true };

export default function DrawerCM(props) {
  const location = useLocation();
  const AuthCTX = useAuth();
  const currentPath = location.pathname.split()[0];
  const { register, getValues, reset } = useForm();

  const { request } = useHttp();

  const [messageCount, setMessageCount] = useState(0);
  const [complaintCount, setComplaintCount] = useState(0);
  const [ticketCount, setTicketCount] = useState(0);
  const [commentCount, setCommentCount] = useState(0);
  const [questionCount, setQuetionCount] = useState(0);

  const getStatus = useCallback(async () => {
    const res = await request({
      url: getStatusRequest,
    });
    setMessageCount(res.new_contact_us_messages_count);
    setComplaintCount(res.new_complaints_count);
    setTicketCount(res.new_tickets_count);
    setCommentCount(res.new_comments_count);
    setQuetionCount(res.new_question_and_answers_count);
  }, [request]);

  useEffect(() => {
    getStatus();
  }, [getStatus]);

  const Users = [
    {
      label: "کاربران",
      smalllabel: "عادی",
      icon: <FaUsers size={26} />,
      url: "/users",
    },
    {
      label: "کاربران",
      smalllabel: "همکار",
      icon: <GroupAddIcon size={26} />,
      url: "/colleague",
    },
  ];
  const ListItems = [
    {
      label: "سفارشات",
      icon: <RiListOrdered size={26} />,
      url: "/orders",
    },
    {
      label: "آمار سفارشات",
      icon: <RiListOrdered size={26} />,
      url: "/orders/Stats",
    },
    { label: "محصولات", icon: <GiSofa size={26} />, url: "/products" },
    { label: "زیردسته ها", icon: <BiCategory size={26} />, url: "/category" },

    {
      label: "نظرات",
      icon:
        commentCount == "0" ? (
          <BiCommentDetail size={26} />
        ) : (
          <Badge color="warning" badgeContent={commentCount}>
            <BiCommentDetail size={26} />
          </Badge>
        ),
      url: "/comment",
    },
    {
      label: "تیکت",
      icon:
        ticketCount == "0" ? (
          <AiFillMessage size={26} />
        ) : (
          <Badge color="warning" badgeContent={ticketCount}>
            <AiFillMessage size={26} />
          </Badge>
        ),
      url: "/ticket",
    },
    {
      label: "پرسش و پاسخ",
      icon:
        questionCount == "0" ? (
          <AiFillQuestionCircle size={26} />
        ) : (
          <Badge color="warning" badgeContent={questionCount}>
            <AiFillQuestionCircle size={26} />
          </Badge>
        ),
      url: "/question-answer",
    },
    {
      label: "پیام ها",
      icon:
        messageCount == "0" ? (
          <MdEmail size={26} />
        ) : (
          <Badge color="warning" badgeContent={messageCount}>
            <MdEmail size={26} />
          </Badge>
        ),
      url: "/message",
    },
    {
      label: "آمار بازدید",
      icon: <BsBarChartLineFill size={26} />,
      url: "/views",
    },
  ];

  const SettingListItems = [
    {
      label: "ارسال پیام",
      icon: <MdNotifications size={26} />,
      url: "/notification",
    },
    { label: "تخفیف ها", icon: <FaPercentage size={26} />, url: "/discount" },
    {
      label: "سوالات متداول",
      icon: <MdHelpOutline size={26} />,
      url: "/question",
    },
    { label: "آموزش", icon: <NewspaperSharpIcon size={26} />, url: "/news" }, 
    { label: "درباره ما", icon: <MdFeed size={26} />, url: "/aboutus" },
    { label: "شعبات", icon: <FaPercentage size={26} />, url: "/branch" },
    { label: "نحوه ثبت سفارش", icon: <FaPercentage size={26} />, url: "/payment/rules" },
    { label: "اسلاید اصلی", icon: <MdImage size={26} />, url: "/mainslider" },
    { label: "اسلاید اکسسوری", icon: <MdImage size={26} />, url: "/slider" },
    {
      label: "ارتباط با ما",
      smalllabel: "مبلمان",
      icon: <MdFeed size={26} />,
      url: "/contact",
    },
    {
      label: "ارتباط با ما",
      smalllabel: "اکسسوری",
      icon: <MdFeed size={26} />,
      url: "/contactaccessory",
    },
    { label: "قوانین", icon: <MdGavel size={26} />, url: "/rules" },
    { label: "حریم خصوصی", icon: <MdPrivacyTip size={26} />, url: "/privacy" },
    { label: "متن سبد خرید", icon: <MdFeed size={26} />, url: "/cartmessage" },
    {
      label: "گواهینامه ها",
      icon: <MdMilitaryTech size={26} />,
      url: "/license",
    },
    { label: "گالری", icon: <MdImage size={26} />, url: "/gallery" },

    {
      label: "شکایات",
      icon:
        complaintCount == "0" ? (
          <MdEmail size={26} />
        ) : (
          <Badge color="warning" badgeContent={complaintCount}>
            <MdEmail size={26} />
          </Badge>
        ),
      url: "/complaint",
    },
  ];

  const [open, setOpen] = useState(window.innerWidth > 900 ? true : false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <StyledAppBar position="fixed" open={open} $drawerWidth={drawerWidth}>
        <Toolbar sx={{ color: (theme) => theme.palette.primary.contrastText }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(open && { display: "none" }) }}
          >
            <MenuIcon />
          </IconButton>

          <StyledTypo variant="h6" noWrap component="div">
            {props.title}
          </StyledTypo>

          {props.onSearch && (
            <StyledSearch>
              <SearchBoxWrapper>
                <IconButton
                  aria-label="close"
                  sx={{ color: "white", mr: 0.5 }}
                  onClick={() => {
                    reset({ search: "" });
                    props.onSearch("");
                  }}
                >
                  <MdClose size={20} />
                </IconButton>

                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  light
                />

                <IconButton
                  aria-label="search"
                  sx={{ color: "white", ml: 0.5 }}
                  onClick={() => props.onSearch(getValues("search"))}
                >
                  <MdSearch size={20} />
                </IconButton>
              </SearchBoxWrapper>

              <StyledInputBase
                placeholder="جستجو"
                inputProps={{ "aria-label": "search" }}
                onKeyDown={(e) =>
                  e.key === "Enter" ? props.onSearch(getValues("search")) : ""
                }
                {...register("search")}
              />
            </StyledSearch>
          )}
        </Toolbar>
      </StyledAppBar>

      <StyledDrawer
        $drawerWidth={drawerWidth}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <StyledDrawerHeader>
          <ImgContainer
            src={logo}
            alt="لوگو"
            objectFit="contain"
            width="150px"
            height="100px"
            sx={{ padding: "10px" }}
          />
          <IconButton
            onClick={handleDrawerClose}
            sx={{ mt: 1, alignSelf: "flex-start" }}
            size="large"
          >
            <ChevronRightIcon sx={{ color: "white" }} />
          </IconButton>
        </StyledDrawerHeader>

        <Divider />

        <StyledList>
          <StyledAccordion>
            <AccordionSummary
              expandIcon={<MdExpandMore size={26} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <StyledSetting>
                <ListItemIcon>
                  <FaUsers size={26} />
                </ListItemIcon>
                <ListItemText>کاربران</ListItemText>
              </StyledSetting>
            </AccordionSummary>
            <StyledAccordionDetails>
              {Users.map((item, index) => (
                <StyledDrawerLink
                  to={item.url}
                  $isActive={item.url === currentPath}
                  key={"label" + index}
                >
                  <ListItem button>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText>
                      {" "}
                      {item.label}{" "}
                      <small style={{ fontSize: "11px" }}>
                        {" "}
                        {item.smalllabel}{" "}
                      </small>
                    </ListItemText>
                  </ListItem>
                </StyledDrawerLink>
              ))}
            </StyledAccordionDetails>
          </StyledAccordion>
          {ADMIN_PREMISSION.isPrimary
            ? ListItems.map((item, index) => (
                <StyledDrawerLink
                  to={item.url}
                  $isActive={item.url === currentPath}
                  key={"label" + index}
                >
                  <ListItem button>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText>
                      {" "}
                      {item.label}{" "}
                      <small style={{ fontSize: "12px" }}>
                        {" "}
                        {item.smalllabel}{" "}
                      </small>
                    </ListItemText>
                  </ListItem>
                </StyledDrawerLink>
              ))
            : ListItems.map((item, index) => {
                return (
                  <StyledDrawerLink
                    to={item.url}
                    $isActive={item.url === currentPath}
                    key={"label" + index}
                  >
                    <ListItem button>
                      <ListItemIcon>{item.icon}</ListItemIcon>
                      <ListItemText>
                        {" "}
                        {item.label}{" "}
                        <small style={{ fontSize: "12px" }}>
                          {" "}
                          {item.smalllabel}{" "}
                        </small>
                      </ListItemText>
                    </ListItem>
                  </StyledDrawerLink>
                );
              })}

          <StyledAccordion>
            <AccordionSummary
              expandIcon={<MdExpandMore size={26} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <StyledSetting>
                <ListItemIcon>
                  <MdSettings size={26} />
                </ListItemIcon>
                <ListItemText>بیشتر</ListItemText>
              </StyledSetting>
            </AccordionSummary>
            <StyledAccordionDetails>
              {SettingListItems.map((item, index) => (
                <StyledDrawerLink
                  to={item.url}
                  $isActive={item.url === currentPath}
                  key={"label" + index}
                >
                  <ListItem button>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText>
                      {" "}
                      {item.label}{" "}
                      <small style={{ fontSize: "11px" }}>
                        {" "}
                        {item.smalllabel}{" "}
                      </small>
                    </ListItemText>
                  </ListItem>
                </StyledDrawerLink>
              ))}
            </StyledAccordionDetails>
          </StyledAccordion>
          <ListItem button onClick={AuthCTX.logout}>
            <ListItemIcon>
              <MdExitToApp size={26} />
            </ListItemIcon>
            <ListItemText>خروج</ListItemText>
          </ListItem>
        </StyledList>
      </StyledDrawer>

      <StyledMain open={open} $drawerWidth={drawerWidth}>
        <StyledDrawerHeader />
        {props.children}
      </StyledMain>
    </Box>
  );
}

DrawerCM.prototype = {
  title: PropTypes.string,
  onSearch: PropTypes.func,
};
